import request from '../utils/request';

export const fetchProductList = params =>
  request.get('/admin/product/list', { params });
export const fetchProductDetail = id =>
  request.get(`/admin/product/detail/${id}`);
export const createProduct = data =>
  // mall-server 实际路由为 POST /admin/product/add
  request.post('/admin/product/add', data);
export const updateProduct = (id, data) =>
  request.put(`/admin/product/update/${id}`, data);
export const deleteProduct = id =>
  request.delete(`/admin/product/delete/${id}`);
export const uploadProductImage = data =>
  request.post('/admin/product/upload', data, { timeout: 120000 });
// 批量更新商品排序
export const updateProductSort = items =>
  request.put('/admin/product/sort', { items });
// 下载导入模板（返回二进制）
export const downloadImportTemplate = () =>
  request.get('/admin/product/import-template', { responseType: 'blob' });
// 批量导入商品
export const importProducts = data =>
  request.post('/admin/product/import', data, { timeout: 120000 });
// 批量上下架
export const batchUpdateProductStatus = (ids, status) =>
  request.put('/admin/product/batch-status', { ids, status });
